export default __webpack_public_path__ + "static/media/contact.30142d2b.vcf";